import { render } from "./verifyregister.vue?vue&type=template&id=c000e682&scoped=true"
import script from "./verifyregister.vue?vue&type=script&lang=js"
export * from "./verifyregister.vue?vue&type=script&lang=js"

import "./verifyregister.vue?vue&type=style&index=0&id=c000e682&lang=scss&scoped=true"

import exportComponent from "/home/hsf/.jenkins/workspace/mmm-overseas-prod-hongkong/rith-h5/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c000e682"]])

export default __exports__